import Cross from "@assets/svg/Cross";
import React, { useEffect } from "react";
import { Modal, StyleSheet, Text, TouchableOpacity, View } from "react-native";
import Image from "react-native-fast-image";
import analytics from "../analytics";

const ModalView = ({
  isChipModal,
  visible,
  icon,
  title,
  body,
  _onPress,
  ctaLeftText,
  ctaRightBgColor,
  ctaRightText,
  ctaLeftBgColor,
  ctaLeftTextColor,
  ctaRightTextColor,
  titleBgColor,
  ctaLeftKey = "NO",
  ctaRightKey = "YES",
}) => {
  useEffect(() => {
    if (!title) return;
    if (visible) {
      analytics.modalViewed({ title, visible });
    } else {
      analytics.modalClosed({ title, visible });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title]);

  return (
    <Modal transparent visible={visible} animationType="fade">
      <View style={styles.backdrop}>
        <View style={styles.container}>
          <Image
            source={{
              uri: icon,
            }}
            style={styles.icon}
          />
          {isChipModal && (
            <TouchableOpacity
              testID="cpAvailAbilityChipModalCross"
              onPress={_onPress("X")}
              style={styles.closeButton}
            >
              <Cross height={10} width={10} />
            </TouchableOpacity>
          )}
          <Text
            style={[
              styles.title,
              {
                color: isChipModal ? titleBgColor : "black",
                backgroundColor:
                  isChipModal && titleBgColor
                    ? `${titleBgColor}14`
                    : "transparent",
                paddingHorizontal: isChipModal ? 16 : 0,
              },
            ]}
          >
            {title}
          </Text>
          <Text style={styles.description}>{body}</Text>
          <View style={styles.buttonRow}>
            <TouchableOpacity
              testID="cpAvailabilityLeftCta"
              style={[styles.ctaButton, { backgroundColor: ctaLeftBgColor }]}
              onPress={_onPress(ctaLeftKey)}
            >
              <Text style={[styles.ctaButtonText, { color: ctaLeftTextColor }]}>
                {ctaLeftText}
              </Text>
            </TouchableOpacity>
            <View style={styles.spacer} />
            <TouchableOpacity
              testID="cpAvailabilityRightCta"
              style={[styles.ctaButton, { backgroundColor: ctaRightBgColor }]}
              onPress={_onPress(ctaRightKey)}
            >
              <Text
                style={[styles.ctaButtonText, { color: ctaRightTextColor }]}
              >
                {ctaRightText}
              </Text>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  backdrop: {
    backgroundColor: "rgba(0,0,0,0.8)",
    justifyContent: "center",
    flex: 1,
  },
  container: {
    marginHorizontal: 15,
    backgroundColor: "white",
    borderRadius: 20,
    position: "relative",
    paddingHorizontal: 20,
    paddingBottom: 20,
    paddingTop: 50,
  },
  title: {
    fontSize: 16,
    fontFamily: "NotoSansDevanagari-Bold",
    marginVertical: 8,
    alignSelf: "flex-start",
    paddingVertical: 4,
    borderRadius: 20,
  },
  description: {
    fontSize: 14,
  },
  closeButton: {
    backgroundColor: "rgba(0,0,0,0.1)",
    justifyContent: "center",
    alignItems: "center",
    height: 24,
    width: 24,
    position: "absolute",
    right: 16,
    top: 16,
    borderRadius: 20,
  },
  ctaButton: {
    borderRadius: 8,
    flex: 1,
  },
  ctaButtonText: {
    fontFamily: "NotoSansDevanagari-SemiBold",
    borderRadius: 8,
    fontSize: 16,
    textAlign: "center",
    paddingVertical: 6,
  },
  buttonRow: {
    marginTop: 32,
    flexDirection: "row",
  },
  spacer: {
    width: 12,
  },
  icon: {
    position: "absolute",
    top: -50,
    left: 24,
    height: 112,
    width: 112,
  },
});

export default ModalView;
